<abs-messages>
  <div class="alert b2b-alerts-messages b2b-alerts-info valign-children-middle" tabindex="-1" *ngIf="showWarning"
    [ngClass]="{'d-none':!showWarning}" tabindex="0" [abs-trap-focus-inside-element]="false">
    <div class="alert-info">
      <em class="icon-alert" role="img" ab2b-alerts-info ria-label="Warning"></em>
    </div>
    <div class="title h3">
      <p *ngFor="let message of messages"> {{message}}</p>
    </div>
    <button type="button" class="close" #closeBtn aria-label="Close" tabindex="0"
      (click)="toggle('showWarning')"></button>
  </div>
</abs-messages>